export  {
    IS_SANDBOX_MODE
}

const MODE={
    DEVELOPMENT:"development",
    RELEASE:"release"

}

/// THIS FLAG IS USED FOR RELEASE
const  BUILD_MODE=MODE.RELEASE;

// THIS FLAG IS USED FOR DEVELOPMENT
 //const  BUILD_MODE=MODE.DEVELOPMENT;

// WE are using this to show , our envoirment is in RELEASE or in DEVELOPMENT
//if IS_SANDBOX_MODE=true, OUR ENVOIMENT is in devlopment vice versa.
const  IS_SANDBOX_MODE=MODE.DEVELOPMENT===BUILD_MODE;





